// หน้าปรับปรุงใบเสร็จรับเงิน — ออกใบเสร็จย้อนหลังหลายใบให้บิลค้างชำระที่มีอยู่แล้ว
//
// การ์ดบนสุด  : เลือกบ้านเลขที่ แล้วกด "เพิ่มเดือน" — เลือกงวดค้างชำระจาก popup ทีเดียวหลายเดือน
// ในแต่ละ tab : ฝั่งซ้าย = ค่าใช้จ่ายของงวดนั้น (อ่านอย่างเดียว ดึงจากบิลจริงใน DB)
//               ฝั่งขวา = ใบเสร็จที่จะออกของงวดนั้น (ออกได้หลายใบ)
//
// กติกา
//   - งวดที่เลือกได้คือบิลค้างชำระของบ้านหลังนั้นเท่านั้น (status_pay = 1) เลือกซ้ำไม่ได้
//   - ต้องเลือกไล่จากงวดเก่าไปใหม่ ปลดงวดเก่าออกโดยที่งวดใหม่ยังเลือกอยู่ไม่ได้
//   - ลบเดือนได้จากเดือนใหม่สุดลงไปเท่านั้น หรือกด "ลบทั้งหมด"
//   - รายการเดียวกันของงวดเดียวกัน ห้ามอยู่ใน 2 ใบ (จะกลายเป็นเก็บเงินซ้ำ)
//   - รายการที่เคยเก็บเงิน/ตัดหนี้ไปแล้วในงวดนั้น ติ๊กไม่ได้
//   - ช่องที่ยอดเป็น 0 ออกใบเสร็จไม่ได้
//   - กดบันทึกครั้งเดียว backend ออกใบเสร็จ + รายการรับชำระ ทุกงวดแบบ atomic
import "../../components/global.js";
import "../../assets/css/bootstrap.css";
import Navbar from "../../components/Navbar";
import Select from "react-select";
import { loading, tokens, select_style, total, alert, toFixed, NumberZero, GET, POST, format_date, float, DatePicker, getStorage, roundToTwo, calculate_water, fieldSorter } from "../../components/CustomComponent.js";
import Swal from "sweetalert2";
import { Modal } from "react-bootstrap";
import React, { Component } from "react";

const r_det = getStorage("role_detail")?.find((item) => item.name === "receipt-adjustment")?.role || [];
const view_r = r_det[0] === 1, create_r = r_det[1] === 1;

const PAYMENT_CASH = 1;
const PAYMENT_TRANSFER = 2;

// เงินสดปัดเศษเป็นขั้นละ 25 สตางค์
const SATANG_STEP = 0.25;

// 11 ช่องค่าใช้จ่ายของบิล — ชื่อและลำดับตรงกับหน้ารับชำระค่าใช้จ่าย (RecordReceipt)
// key เป็นชื่อฝั่ง API (late_payment = เบี้ยปรับ ซึ่งในตารางคือ total_cost_late)
const PAYMENT_TITLES = {
  water_bill: "ค่าใช้น้ำประจำเดือน",
  equipment_maintenance_fee: "ค่ารักษาอุปกรณ์การใช้น้ำ",
  common_expenses: "ค่าใช้จ่ายส่วนกลาง",
  fire_cost: "ค่าเบี้ยประกัน",
  waste_cost: "ค่าบริการจัดเก็บขยะ",
  cable_cost: "ค่าบริการเคเบิล",
  other_income: "ค่าใช้จ่ายอื่นๆ",
  add_debt: "รายการเพิ่มหนี้",
  reduce_debt: "รายการลดหนี้",
  meter_connect_cost: "ค่าต่อกลับมิเตอร์",
  late_payment: "ค่าปรับชำระล่าช้า",
};
const PAYMENT_KEYS = Object.keys(PAYMENT_TITLES);

// รายการค่าใช้จ่ายในใบเสร็จ แสดงเป็นตารางแถวละ 3 ช่อง
const PAY_COLUMNS = 3;
const PAY_ROWS = PAYMENT_KEYS.reduce((rows, key, i) => {
  if (i % PAY_COLUMNS === 0) rows.push([]);
  rows[rows.length - 1].push(key);
  return rows;
}, []);

// ลดหนี้เป็นตัวเดียวที่หักออกจากยอด
const signOf = (key) => (key === "reduce_debt" ? -1 : 1);

// ค่าที่ backend อาจส่งมาเป็นข้อความมี comma ต้องแปลงเป็นตัวเลขก่อนคิด
const COMMA_FIELDS = ["late_payment", "common_expenses", "cable_cost", "fire_cost"];
const parseCost = (value) => Number(String(value || 0).replace(/,/g, ""));

// วันที่รับชำระต้องไม่ก่อนวันที่จดมาตรของงวดนั้น (ออกใบเสร็จก่อนวันที่มีหนี้ไม่ได้)
// DatePicker เช็คช่วงแบบ "มากกว่า min" (ไม่รวมตัว min) จึงต้องส่งวันก่อนหน้า 1 วันเข้าไป
const datePickerMin = (dateStr) => {
  if (!dateStr) return undefined;
  const d = new Date(dateStr);
  d.setDate(d.getDate() - 1);
  return d;
};

// เทียบเฉพาะวัน ตัดเวลาออก
const isBefore = (dateStr, limitStr) => {
  if (!dateStr || !limitStr) return false;
  const d = new Date(dateStr), limit = new Date(limitStr);
  d.setHours(0, 0, 0, 0);
  limit.setHours(0, 0, 0, 0);
  return d.getTime() < limit.getTime();
};

const addressLabel = (item) => `อาคาร ${item.building} ห้อง ${item.address_number}`;

// ช่องนี้เก็บเงิน/ตัดหนี้ไปแล้วหรือยัง
// NOTE s_* ระดับงวดเป็นสถานะรวมของใบ เชื่อรายช่องไม่ได้ ยึด transaction_payments/writeoff_list เป็นหลัก
// (ตรงกับหน้า RecordReceipt — หลังยกเลิกใบเสร็จ/ยกเลิกตัดหนี้ backend ไม่ได้ล้าง s_* ระดับงวด)
const isSettled = (item, sKey) => [item.transaction_payments, item.writeoff_list].some((list) => list?.some((p) => p[sKey]));

// ช่องนี้ของงวดนี้ "จบแล้ว" ใช่ไหม
const isDone = (row, key) => isSettled(row, `s_${key}`) || !!row.payment_list?.find((e) => e.title === key && e.status_pay);

// ยอดของช่องหนึ่งในงวดหนึ่ง — ช่องที่จบไปแล้วถือเป็น 0 (เก็บซ้ำไม่ได้)
const amountOf = (row, key) => (isDone(row, key) ? 0 : Number(row[key] || 0) * signOf(key));

// ยอดค้างจริงของบิล 1 งวด (นับเฉพาะช่องที่ยังไม่จบ)
const unpaidAmountOf = (row) => PAYMENT_KEYS.reduce((sum, key) => sum + amountOf(row, key), 0);

// เงินสดต้องปัดยอดขึ้นให้ลงตัวขั้นละ 25 สตางค์ — คืนส่วนต่างที่ต้องปรับเพิ่ม
const calcChangeSatang = (amount) => {
  const remainder = amount % SATANG_STEP;
  if (remainder === 0) return 0;
  return roundToTwo(SATANG_STEP - remainder);
};

// ค่าตั้งต้นของใบเสร็จ 1 ใบ
const emptyReceipt = (record_date) => ({
  key: `${Date.now()}-${Math.random()}`,
  record_date: record_date || "",
  record_time: "00:00",
  payment_type: PAYMENT_CASH,
  transfer_date: "",
  transfer_time: "",
  collapsed: false, // ย่อการ์ดใบนี้อยู่หรือไม่ (แสดงผลอย่างเดียว ไม่ส่งไป backend)
  items: {},
  change_satang: 0,
  add_on_add_debt: 0,
  add_on_add_debt_remark: "",
  add_on_reduce_debt: 0,
  add_on_reduce_debt_remark: "",
});

// งวด 1 tab จากบิลค้าง 1 ใบ
const tabFromRow = (row) => {
  const date = format_date(row.datetime_create, "yyyy-mm-dd", "en");
  return { key: row.record_water_id, record_water_id: row.record_water_id, date, row, receipts: [emptyReceipt(date)] };
};

export default class ReceiptAdjustment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      customer_options: [],
      address: null,

      record_water_list: [], // บิลค้างทุกงวดของบ้านที่เลือก เรียงงวดเก่า → ใหม่
      ref_customer_id: "", // ลูกหนี้ของบิลค้างชุดนี้ (เลือกข้ามลูกหนี้ไม่ได้)

      tabs: [], // [{ key, record_water_id, date, row, receipts }] — 1 งวด = 1 tab
      active: 0,

      modal_month: false,
      month_rows: [], // สำเนาบิลค้างที่ใช้ใน popup (มี checked)

      created_receipts: [], // เลข IW ที่เพิ่งสร้าง — ไว้ให้กดพิมพ์ทีละใบ
      modal_print: false, // popup รายการใบเสร็จที่เพิ่งออก (ปิดได้ด้วยปุ่มปิดเท่านั้น)
    };
  }

  async componentDidMount() {
    if (!view_r) return;
    loading(true);
    await this.GetCustomerAll();
    loading(false);
  }

  // ---------- ตัวช่วย ----------

  pid = () => getStorage("project_id");

  patchTab = (index, patch, callback) =>
    this.setState({ tabs: this.state.tabs.map((tab, i) => (i === index ? { ...tab, ...patch } : tab)) }, callback);

  patchReceipt = (monthIndex, receiptIndex, patch, callback) =>
    this.patchTab(
      monthIndex,
      { receipts: this.state.tabs[monthIndex].receipts.map((r, i) => (i === receiptIndex ? { ...r, ...patch } : r)) },
      callback
    );

  // ยอดของใบเสร็จ 1 ใบ = เฉพาะช่องที่ใบนี้เก็บ
  receiptTotalOf = (row, receipt) => PAYMENT_KEYS.reduce((sum, key) => (receipt.items[key] ? sum + amountOf(row, key) : sum), 0);

  // ค่าส่วนต่างของใบเสร็จ 1 ใบ = เพิ่มหนี้ - ลดหนี้ (ปรับเศษแยกบรรทัดต่างหาก)
  receiptDiffOf = (receipt) => Number(receipt.add_on_add_debt || 0) - Number(receipt.add_on_reduce_debt || 0);

  // ยอดสุทธิของใบเสร็จ 1 ใบ (ค่าใช้จ่ายที่เลือก + ค่าส่วนต่าง + ปรับเศษ)
  receiptFinalOf = (row, receipt) => this.receiptTotalOf(row, receipt) + this.receiptDiffOf(receipt) + Number(receipt.change_satang || 0);

  // ช่องนี้ถูกใบไหนของงวดนี้จองไว้ (คืน index ของใบ หรือ -1)
  claimedBy = (tab, key) => tab.receipts.findIndex((r) => r.items[key]);

  // ---------- โหลดข้อมูล ----------

  // ห้องทั้งหมดในโครงการ (ไม่กรองตามรอบที่จดแล้ว เพราะหน้านี้ทำงานกับงวดย้อนหลัง)
  GetCustomerAll = async () => {
    const r = await GET(tokens, `v1/TH/customer-manage/filter-search/page/0/${this.pid()}`, { data_search: "", transfer_date: "", status_transfer: "" });
    if (!r?.status) return;
    this.setState({
      customer_options: r.data.data.map((item) => ({
        value: item.address_number,
        label: addressLabel(item),
        building: item.building,
        full_name: item.full_name,
        address: item.address,
      })),
    });
  };

  // บิลค้างทุกงวดของบ้านที่เลือก — API เดียวกับหน้ารับชำระค่าใช้จ่าย เรียงงวดเก่า → ใหม่
  GetBills = async (address_number) => {
    loading(true);
    const r = await GET(tokens, `v1/TH/record-receipt/by-address/${this.pid()}`, { address_number });
    loading(false);
    if (!r?.status) return;

    const rows = r.data.data;
    rows.forEach((row) => COMMA_FIELDS.forEach((k) => (row[k] = parseCost(row[k]))));

    this.setState({ record_water_list: rows, ref_customer_id: rows.length ? rows[0].ref_customer_id : "" });
    if (!rows.length) alert("warning", "แจ้งเตือน", "บ้านเลขที่นี้ไม่มีบิลค้างชำระ");
  };

  // ---------- การ์ดด้านบน: เลือกห้อง + เดือน ----------

  // เปลี่ยนห้องแล้วใบเสร็จที่ตั้งไว้ใช้ไม่ได้ (คนละบิล) ต้องถามก่อนล้าง
  changeAddress = (option) => {
    const apply = () => this.setState({ address: option, tabs: [], active: 0, record_water_list: [], ref_customer_id: "" }, () => this.GetBills(option.value));

    if (!this.state.tabs.length) return apply();

    Swal.fire({
      icon: "warning",
      title: "เปลี่ยนบ้านเลขที่",
      text: "ใบเสร็จที่ตั้งไว้ของทุกงวดจะถูกล้าง ต้องการเปลี่ยนหรือไม่",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: "เปลี่ยน",
      cancelButtonText: "ยกเลิก",
    }).then((res) => {
      if (res.isConfirmed) apply();
    });
  };

  openMonthModal = () => {
    if (!this.state.address) return alert("warning", "แจ้งเตือน", "กรุณาเลือกบ้านเลขที่ก่อน");
    if (!this.state.record_water_list.length) return alert("warning", "แจ้งเตือน", "บ้านเลขที่นี้ไม่มีบิลค้างชำระ");

    const picked = this.state.tabs.map((t) => t.record_water_id);
    this.setState({
      modal_month: true,
      month_rows: this.state.record_water_list.map((row) => ({ ...row, checked: picked.includes(row.record_water_id) })),
    });
  };

  // ติ๊กงวดใหม่ = ติ๊กงวดเก่ากว่าทั้งหมดให้ด้วย / ปลดงวดเก่า = ปลดงวดใหม่กว่าทั้งหมด
  // (ลิสต์เรียงเก่า → ใหม่) — เก็บเงินข้ามงวดโดยเว้นงวดเก่าไว้ไม่ได้
  toggleMonthRow = (index, checked) => {
    const refId = this.state.ref_customer_id;
    const row = this.state.month_rows[index];
    if (refId !== "" && refId !== row.ref_customer_id) return alert("warning", "แจ้งเตือน", "ไม่สามารถเลือกบิลที่มีลูกหนี้ต่างกันกันได้");

    const list = this.state.month_rows.map((e) => ({ ...e }));
    list.forEach((el, i) => {
      if (checked && i <= index && refId === el.ref_customer_id) el.checked = true;
      else if (!checked && i > index) el.checked = false;
    });
    list[index].checked = checked;
    this.setState({ month_rows: list });
  };

  confirmMonths = () => {
    const selected = this.state.month_rows.filter((e) => e.checked);
    if (!selected.length) return alert("warning", "แจ้งเตือน", "กรุณาเลือกอย่างน้อย 1 เดือน");

    const keep = selected.map((e) => e.record_water_id);
    // งวดที่ถูกเอาออกและมีใบเสร็จที่เลือกรายการไว้แล้ว = ข้อมูลจะหาย ต้องเตือนก่อน
    const lost = this.state.tabs.filter((t) => !keep.includes(t.record_water_id) && t.receipts.some((r) => PAYMENT_KEYS.some((k) => r.items[k])));

    const build = () => {
      const tabs = selected.map((row) => {
        const old = this.state.tabs.find((t) => t.record_water_id === row.record_water_id);
        return old ? { ...old, row } : tabFromRow(row);
      });
      this.setState({ tabs, active: tabs.length - 1, modal_month: false, month_rows: [] });
    };

    if (!lost.length) return build();

    Swal.fire({
      icon: "warning",
      title: "ยืนยันการเลือกเดือน",
      text: `มี ${lost.length} งวดที่ถูกเอาออกและตั้งใบเสร็จไว้แล้ว ข้อมูลใบเสร็จของงวดนั้นจะหาย`,
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: "ยืนยัน",
      cancelButtonText: "ยกเลิก",
    }).then((res) => {
      if (res.isConfirmed) build();
    });
  };

  // ---------- ใบเสร็จในงวดนั้น ----------

  addReceipt = (monthIndex) => {
    const tab = this.state.tabs[monthIndex];
    this.patchTab(monthIndex, { receipts: [...tab.receipts, emptyReceipt(tab.date)] });
  };

  toggleReceiptItem = (monthIndex, receiptIndex, key) => {
    const tab = this.state.tabs[monthIndex];
    const receipt = tab.receipts[receiptIndex];

    if (!receipt.items[key]) {
      if (isDone(tab.row, key)) return alert("warning", "แจ้งเตือน", `${PAYMENT_TITLES[key]} ของงวดนี้ถูกชำระไปแล้ว ไม่สามารถเก็บซ้ำได้`);
      if (amountOf(tab.row, key) === 0) return alert("warning", "แจ้งเตือน", `${PAYMENT_TITLES[key]} ยอดเป็น 0 ออกใบเสร็จไม่ได้`);
      const claimed = this.claimedBy(tab, key);
      if (claimed !== -1) return alert("warning", "แจ้งเตือน", `${PAYMENT_TITLES[key]} ถูกเลือกไว้ในใบที่ ${claimed + 1} แล้ว`);
    }

    this.patchReceipt(monthIndex, receiptIndex, { items: { ...receipt.items, [key]: !receipt.items[key] } }, () => this.reseedSatang(monthIndex, receiptIndex));
  };

  // เงินสดต้องปัดยอดขึ้นเป็นขั้นละ 25 สตางค์ — คิดใหม่ทุกครั้งที่รายการในใบเปลี่ยน
  reseedSatang = (monthIndex, receiptIndex) => {
    const tab = this.state.tabs[monthIndex];
    const receipt = tab.receipts[receiptIndex];
    const satang = Number(receipt.payment_type) === PAYMENT_CASH ? calcChangeSatang(this.receiptTotalOf(tab.row, receipt)) : 0;
    this.patchReceipt(monthIndex, receiptIndex, { change_satang: satang });
  };

  confirmDelete = (target) => {
    const title = target.type === "receipt" ? "ยืนยันการลบใบเสร็จ" : "ยืนยันการลบงวด";
    const text =
      target.type === "all"
        ? "งวดที่เลือกไว้และใบเสร็จทั้งหมดจะถูกลบ ต้องการลบหรือไม่"
        : target.type === "month"
        ? "งวดใหม่สุดและใบเสร็จของงวดนั้นจะถูกลบ ต้องการลบหรือไม่"
        : `ต้องการลบใบเสร็จที่ ${target.receipt + 1} ใช่หรือไม่`;

    Swal.fire({
      icon: "warning",
      title,
      text,
      showCancelButton: true, cancelButtonColor: "#d33",
      confirmButtonText: "ลบ", cancelButtonText: "ยกเลิก",
    }).then((res) => {
      if (!res.isConfirmed) return;

      if (target.type === "all") return this.setState({ tabs: [], active: 0 });

      // ลบเดือนได้จากเดือนใหม่สุดเท่านั้น (เดือนก่อนหน้ายังต้องอยู่ ไม่งั้นเก็บเงินข้ามงวด)
      if (target.type === "month") {
        const tabs = this.state.tabs.slice(0, -1);
        return this.setState({ tabs, active: Math.max(tabs.length - 1, 0) });
      }

      const tab = this.state.tabs[target.month];
      this.patchTab(target.month, { receipts: tab.receipts.filter((_, i) => i !== target.receipt) });
    });
  };

  // ---------- บันทึก ----------

  Create = () => {
    const { tabs, address } = this.state;
    if (!address) return alert("warning", "แจ้งเตือน", "กรุณาเลือกบ้านเลขที่");
    if (!tabs.length) return alert("warning", "แจ้งเตือน", "กรุณาเพิ่มเดือนอย่างน้อย 1 เดือน");

    for (const tab of tabs) {
      const period = format_date(tab.date, "mm/yyyy");
      if (!tab.receipts.length) return alert("warning", "แจ้งเตือน", `งวด ${period} : กรุณาเพิ่มใบเสร็จอย่างน้อย 1 ใบ`);

      for (let i = 0; i < tab.receipts.length; i++) {
        const receipt = tab.receipts[i];
        const items = PAYMENT_KEYS.filter((key) => receipt.items[key]);
        if (!items.length) return alert("warning", "แจ้งเตือน", `งวด ${period} ใบที่ ${i + 1} : ยังไม่ได้เลือกรายการ`);
        if (!receipt.record_date) return alert("warning", "แจ้งเตือน", `งวด ${period} ใบที่ ${i + 1} : กรุณาระบุวันที่รับชำระ`);
        if (isBefore(receipt.record_date, tab.date))
          return alert("warning", "แจ้งเตือน", `งวด ${period} ใบที่ ${i + 1} : วันที่รับชำระต้องไม่ก่อนวันที่จดมาตร (${format_date(tab.date, "dd/mm/yyyy")})`);
        if (Number(receipt.payment_type) === PAYMENT_TRANSFER && !receipt.transfer_date)
          return alert("warning", "แจ้งเตือน", `งวด ${period} ใบที่ ${i + 1} : กรุณาระบุวันที่โอน`);
        if (this.receiptFinalOf(tab.row, receipt) <= 0) return alert("warning", "แจ้งเตือน", `งวด ${period} ใบที่ ${i + 1} : ยอดสุทธิต้องมากกว่า 0`);
      }
    }

    const receiptCount = tabs.reduce((sum, tab) => sum + tab.receipts.length, 0);

    Swal.fire({
      title: "ยืนยันการปรับปรุงใบเสร็จ",
      text: `ระบบจะออกใบเสร็จ ${receiptCount} ใบ ให้บิลค้าง ${tabs.length} งวด และถือว่าชำระเงินแล้ว`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "บันทึกข้อมูล",
      cancelButtonText: "ยกเลิก",
    }).then(async (res) => {
      if (!res.isConfirmed) return;

      loading(true);
      const body = {
        address_number: address.value,
        // ยอดของบิลไม่ส่งไป — backend อ่านจาก record_water_id เอง (ห้ามเชื่อยอดจากหน้าจอ)
        bills: tabs.map((tab) => ({
          record_water_id: tab.record_water_id,
          receipts: tab.receipts.map((receipt) => ({
            record_date: receipt.record_date,
            record_time: receipt.record_time || "00:00",
            payment_type: Number(receipt.payment_type) || PAYMENT_CASH,
            transfer_date: Number(receipt.payment_type) === PAYMENT_TRANSFER ? receipt.transfer_date || null : null,
            transfer_time: Number(receipt.payment_type) === PAYMENT_TRANSFER ? receipt.transfer_time || null : null,
            items: PAYMENT_KEYS.filter((key) => receipt.items[key]),
            change_satang: Number(receipt.change_satang || 0),
            add_on_add_debt: Number(receipt.add_on_add_debt || 0),
            add_on_add_debt_remark: receipt.add_on_add_debt_remark || "",
            add_on_reduce_debt: Number(receipt.add_on_reduce_debt || 0),
            add_on_reduce_debt_remark: receipt.add_on_reduce_debt_remark || "",
          })),
        })),
      };

      const r = await POST(tokens, `v1/TH/record-water/backdate-bill/${this.pid()}`, body);
      if (!r?.status) return loading(false);

      // คิดยอดค้าง/เบี้ยปรับใหม่ของห้องนี้
      await calculate_water(address.value);

      // NOTE ห้ามวน window.open เปิดใบเสร็จเองทีละใบ — เบราว์เซอร์บล็อก popup ที่ไม่ได้เกิดจากการกดของผู้ใช้
      // (ได้แค่ใบแรก) และหน้าเอกสารทุกใบอ่านข้อมูลจาก localStorage คีย์เดียวกัน ("DATA_")
      // ใบหลัง ๆ จะเขียนทับกันจนทุกแท็บกลายเป็นใบเดียวกัน
      // จึงโชว์รายการเลขที่ใบเสร็จให้กดพิมพ์ทีละใบแทน — การกดเป็น user gesture เปิดแท็บได้เสมอ
      this.setState({
        created_receipts: r.data.data?.iw_numbers || [],
        modal_print: !!(r.data.data?.iw_numbers || []).length,
        address: null,
        record_water_list: [],
        ref_customer_id: "",
        tabs: [],
        active: 0,
      });

      loading(false);
      alert("success", "สำเร็จ", `ปรับปรุงใบเสร็จรับเงินเรียบร้อยแล้ว ${receiptCount} ใบ`);
    });
  };

  // ประกอบข้อมูลใบเสร็จ 1 ใบ (รูปแบบเดียวกับหน้า RecordReceipt) — คืน null ถ้าไม่พบ
  buildReceiptData = async (iw_number) => {
    try {
      const array_cost = ["add_debt", "cable_cost", "common_expenses", "equipment_maintenance_fee", "fire_cost", "late_payment", "meter_connect_cost", "other_income", "reduce_debt", "waste_cost", "water_bill"];
      let result = await GET(tokens, "v1/TH/record-receipt/history/by-iw-number/" + getStorage("project_id"), { iw_number });
      if (!result?.status) return null;

      let data = result.data.data;
      const baseHeader = {
        project_name: getStorage("project_name"),
        project_address: `เลขที่ ${getStorage("project_address")}\nเบอร์โทรติดต่อ  ${getStorage("phone_number")} เลขที่ผู้เสียภาษี ${getStorage("tax_number")}`,
        cutomer_name: data.full_name,
        cutomer_address: data.address || data.address_number,
        number: data.iw_number,
        date: format_date(data.record_date, "dd mmmm yyyy"),
        payment: data.payment_type === 1 ? "เงินสด" : "โอนเงินเข้าบัญชีนิติฯ",
        payment_date: `${format_date(data.transfer_date || data.record_date, "dd/mm/yyyy")} เวลา ${(data.transfer_time || data.record_time)?.slice(0, 5)}`,
      };

      data.transaction_payments = data.transaction_payments.sort(fieldSorter(["water_current_month"]));
      const getP = (type) => (data.transaction_payments[0][`s_${type}`] ? data.transaction_payments[0][type === "late_payment" ? "total_cost_late" : type] : 0);
      const getT = (item) => {
        let past_total = 0;
        array_cost.map((type) => {
          if (type === "reduce_debt") past_total -= total(item.filter((e) => e[`s_${type}`]), type);
          else if (type === "late_payment") past_total += total(item.filter((e) => e[`s_${type}`]), "total_cost_late");
          else past_total += total(item.filter((e) => e[`s_${type}`]), type);
          return null;
        });
        return parseFloat(past_total.toFixed(2));
      };
      const water_list_price = getT(data.transaction_payments.filter((e, i) => i !== 0));
      const total_calc = water_list_price + getT(data.transaction_payments.filter((e, i) => i === 0)) + data.add_on_add_debt - data.add_on_reduce_debt;

      const lastMonth = new Date(data.last_date);
      lastMonth.setMonth(lastMonth.getMonth() - 1);

      return {
        ...baseHeader,
        water_current_month: data.last_date,
        water_last_month: data.brefore_last_date !== data.last_date ? data.brefore_last_date : format_date(lastMonth, "yyyy-mm-dd", "en"),
        last_gauge_number: data.last_gauge_number,
        current_gauge_number: data.current_gauge_number,
        unit_used: data.unit_used,
        water_bill: getP("water_bill"),
        equipment_maintenance_fee: getP("equipment_maintenance_fee"),
        waste_cost: getP("waste_cost"),
        common_expenses: getP("common_expenses"),
        water_list: data.transaction_payments || [],
        water_list_price,
        // ตัวเลขแสดงผลเท่านั้น (ไม่เข้า water_list_price/total) = ค่าต่อกลับมิเตอร์งวดปัจจุบัน + งวดค้างที่ s_meter_connect_cost=true เหมือน New Print (RecordReceipt.js)
        meter_connect_cost: getP("meter_connect_cost") + total(data.transaction_payments.filter((e, i) => i !== 0 && e.s_meter_connect_cost), "meter_connect_cost"),
        total_cost_late: getP("late_payment"),
        fire_cost: getP("fire_cost"),
        cable_cost: getP("cable_cost"),
        other_income: getP("other_income"),
        add_debt: getP("add_debt"),
        add_on_add_debt: data.add_on_add_debt,
        reduce_debt: getP("reduce_debt"),
        add_on_reduce_debt: data.add_on_reduce_debt,
        total: total_calc,
        change_satang: data.change_satang,
      };
    } catch (e) {
      console.log(e);
      return null;
    }
  };

  // พิมพ์ใบเสร็จใบเดียว
  Print = async (iw_number) => {
    loading(true);
    const data_print = await this.buildReceiptData(iw_number);
    loading(false);
    if (!data_print) return alert("warning", "แจ้งเตือน", "ไม่มีใบแจ้งหนี้");
    localStorage.setItem("DATA_", JSON.stringify(data_print));
    window.open("/doc/receipt", "_blank");
  };

  // พิมพ์ใบเสร็จทุกใบต่อกันในเอกสารเดียว (ขึ้นหน้าใหม่ทุกใบ)
  PrintAll = async () => {
    const { created_receipts } = this.state;
    if (!created_receipts.length) return;
    loading(true);
    const list = [];
    for (const iw_number of created_receipts) {
      const data_print = await this.buildReceiptData(iw_number);
      if (data_print) list.push(data_print);
    }
    loading(false);
    if (!list.length) return alert("warning", "แจ้งเตือน", "ไม่มีใบแจ้งหนี้");
    // หน้าเอกสารรับได้ทั้ง object เดียวและ array — ส่ง array เพื่อพิมพ์ต่อกันทีเดียว
    localStorage.setItem("DATA_", JSON.stringify(list));
    window.open("/doc/receipt", "_blank");
  };

  // ---------- ส่วนแสดงผล ----------

  // สถานะของช่องค่าใช้จ่าย 1 ช่องในงวดที่เปิดอยู่
  itemStatus = (tab, key) => {
    if (isDone(tab.row, key)) return { text: "ชำระไปแล้ว", className: "text-secondary" };
    const claimed = this.claimedBy(tab, key);
    if (claimed !== -1) return { text: `อยู่ในใบที่ ${claimed + 1}`, className: "text-primary" };
    if (amountOf(tab.row, key) === 0) return { text: "-", className: "text-secondary" };
    return { text: "ยังไม่ออกใบเสร็จ", className: "text-danger" };
  };

  // ปรับเศษ / เพิ่มหนี้ / ลดหนี้ ของใบเสร็จใบนี้ (ชุดเดียวกับ popup ชำระเงินของหน้ารับชำระ)
  renderAddOn = (monthIndex, receiptIndex, receipt) => {
    const money = (field, maxLength) => (
      <input
        className="form-control input-edit w-100 text-right"
        type="text"
        maxLength={maxLength}
        value={receipt[field]}
        onChange={(e) => float(e.target.value, 3) && this.patchReceipt(monthIndex, receiptIndex, { [field]: e.target.value || 0 })}
      />
    );
    const text = (field) => (
      <input
        className="form-control input-edit w-100"
        type="text"
        placeholder="กรอกข้อมูล"
        value={receipt[field]}
        onChange={(e) => this.patchReceipt(monthIndex, receiptIndex, { [field]: e.target.value })}
      />
    );

    return (
      <div className="border-top mt-2 pt-2">
        {/* จัดเป็นคอลัมน์ — ยอดเงิน 3 ช่องแถวเดียว หมายเหตุอีกแถว ไม่ยาวลงมาทีละบรรทัด */}
        <div className="row">
          <div className="col-6 col-xl-4 mb-2">
            <label>ปรับเศษ (บาท)</label>
            {money("change_satang", 5)}
          </div>
          <div className="col-6 col-xl-4 mb-2">
            <label>เพิ่มหนี้ (บาท)</label>
            {money("add_on_add_debt", 9)}
          </div>
          <div className="col-6 col-xl-4 mb-2">
            <label>ลดหนี้ (บาท)</label>
            {money("add_on_reduce_debt", 9)}
          </div>
          <div className="col-12 col-xl-6 mb-2">
            <label>หมายเหตุเพิ่มหนี้</label>
            {text("add_on_add_debt_remark")}
          </div>
          <div className="col-12 col-xl-6 mb-2">
            <label>หมายเหตุลดหนี้</label>
            {text("add_on_reduce_debt_remark")}
          </div>
        </div>
      </div>
    );
  };

  renderReceiptCard = (tab, monthIndex, receipt, receiptIndex) => {
    const isTransfer = Number(receipt.payment_type) === PAYMENT_TRANSFER;

    return (
      <div className="card border p-3 mb-3" key={receipt.key}>
        {/* กดแถบหัวใบตรงไหนก็ย่อ/ขยายได้ — งวดที่มีใบเสร็จหลายใบจะได้ไม่ต้องเลื่อนยาว */}
        <div
          className="d-flex align-items-center justify-content-between mb-2 pointer"
          onClick={() => this.patchReceipt(monthIndex, receiptIndex, { collapsed: !receipt.collapsed })}
        >
          <b>
            {receipt.collapsed ? "\u25b8" : "\u25be"} ใบเสร็จที่ {receiptIndex + 1}
          </b>
          <div className="d-flex align-items-center">
            {receipt.collapsed && <b className="mr-3">฿{toFixed(this.receiptFinalOf(tab.row, receipt))}</b>}
            <label
              className="wpx-30 hpx-30 bg-danger-light rounded-1 d-flex align-items-center justify-content-center mb-0 icon text-danger pointer"
              onClick={(e) => {
                e.stopPropagation(); // ปุ่มลบต้องไม่ไปสลับย่อ/ขยายของหัวใบ
                this.confirmDelete({ type: "receipt", month: monthIndex, receipt: receiptIndex });
              }}
            >
              {""}
            </label>
          </div>
        </div>

        {!receipt.collapsed && (
          <>
            <div className="row">
              <div className="col-6 mb-2">
                <label>วันที่รับชำระ</label>
                <DatePicker
                  className="form-control input-edit w-100"
                  value={receipt.record_date}
                  min={datePickerMin(tab.date)}
                  onChange={(e) => {
                    // กันเคสที่ค่าหลุดมาจากทางอื่น — ห้ามก่อนวันที่จดมาตรของงวดนี้เด็ดขาด
                    if (isBefore(e, tab.date)) {
                      return alert("warning", "แจ้งเตือน", `วันที่รับชำระต้องไม่ก่อนวันที่จดมาตร (${format_date(tab.date, "dd/mm/yyyy")})`);
                    }
                    this.patchReceipt(monthIndex, receiptIndex, { record_date: e });
                  }}
                />
              </div>
              <div className="col-6 mb-2">
                <label>เวลา</label>
                <input type="time" className="form-control w-100 input-edit" value={receipt.record_time} onChange={(e) => this.patchReceipt(monthIndex, receiptIndex, { record_time: e.target.value })} />
              </div>

              <div className="col-12 mb-2">
                <label>วิธีการชำระ</label>
                <div className="d-flex">
                  <div className="d-flex wpx-100 align-items-center">
                    <input
                      type="radio"
                      checked={!isTransfer}
                      onChange={(e) =>
                        e.target.checked &&
                        this.patchReceipt(monthIndex, receiptIndex, { payment_type: PAYMENT_CASH, transfer_date: "", transfer_time: "" }, () => this.reseedSatang(monthIndex, receiptIndex))
                      }
                    />
                    <label className="mb-0 ml-2">เงินสด</label>
                  </div>
                  <div className="d-flex wpx-100 align-items-center">
                    <input
                      type="radio"
                      checked={isTransfer}
                      onChange={(e) => e.target.checked && this.patchReceipt(monthIndex, receiptIndex, { payment_type: PAYMENT_TRANSFER, change_satang: 0 })}
                    />
                    <label className="mb-0 ml-2">เงินโอน</label>
                  </div>
                </div>
              </div>

              {isTransfer && (
                <>
                  <div className="col-6 mb-2">
                    <label>วันที่โอน</label>
                    <DatePicker className="form-control input-edit w-100" value={receipt.transfer_date} onChange={(e) => this.patchReceipt(monthIndex, receiptIndex, { transfer_date: e })} />
                  </div>
                  <div className="col-6 mb-2">
                    <label>เวลาโอน</label>
                    <input type="time" className="form-control w-100 input-edit" value={receipt.transfer_time} onChange={(e) => this.patchReceipt(monthIndex, receiptIndex, { transfer_time: e.target.value })} />
                  </div>
                </>
              )}
            </div>

            <label className="mt-2">รายการที่เก็บในใบนี้</label>
            {/* ตาราง 3 ช่องต่อแถว — สวิตช์ผูก id กับ label ด้วย htmlFor กดที่ชื่อรายการก็สลับได้ */}
            <div className="table-responsive">
              <table className="table table-bordered pay-table mb-0">
                <tbody>
                  {PAY_ROWS.map((chunk, rowIndex) => (
                    <tr key={rowIndex}>
                      {chunk.map((key) => {
                        const claimed = this.claimedBy(tab, key);
                        const disabled = isDone(tab.row, key) || amountOf(tab.row, key) === 0 || (claimed !== -1 && claimed !== receiptIndex);
                        const switchId = `receipt-item-${monthIndex}-${receiptIndex}-${key}`;
                        return (
                          <td key={key} className={receipt.items[key] ? "is-on" : ""}>
                            <div className="d-flex align-items-center justify-content-between">
                              <div className="form-check form-switch switch-pay mb-0">
                                <input
                                  className="form-check-input mr-2"
                                  type="checkbox"
                                  role="switch"
                                  id={switchId}
                                  checked={!!receipt.items[key]}
                                  disabled={disabled}
                                  onChange={() => this.toggleReceiptItem(monthIndex, receiptIndex, key)}
                                />
                                <label className={`form-check-label mb-0 ${disabled ? "text-secondary" : ""}`} htmlFor={switchId}>
                                  {PAYMENT_TITLES[key]}
                                </label>
                              </div>
                              <label className={`pay-amount mb-0 ${disabled ? "text-secondary" : ""}`}>{toFixed(amountOf(tab.row, key))}</label>
                            </div>
                          </td>
                        );
                      })}
                      {/* แถวสุดท้ายไม่ครบ 3 ช่อง เติมช่องว่างให้เส้นตารางไม่ขาด */}
                      {chunk.length < PAY_COLUMNS && <td colSpan={PAY_COLUMNS - chunk.length} />}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {this.renderAddOn(monthIndex, receiptIndex, receipt)}

            {/* สรุปยอดท้ายใบ — แยกยอดค่าใช้จ่ายกับส่วนต่าง เพื่อให้เห็นว่ายอดสุทธิมาจากไหน */}
            <div className="w-100 border-top mt-2 pt-2">
              <div className="d-flex justify-content-between mb-1">
                <span>รวมค่าใช้จ่าย</span>
                <span className="pay-amount">฿{toFixed(this.receiptTotalOf(tab.row, receipt))}</span>
              </div>
              <div className="d-flex justify-content-between mb-1">
                <span>ค่าส่วนต่าง <small className="text-secondary">(เพิ่มหนี้ − ลดหนี้)</small></span>
                <span className="pay-amount">฿{toFixed(this.receiptDiffOf(receipt))}</span>
              </div>
              <div className="d-flex justify-content-between mb-1">
                <span>ปรับเศษ</span>
                <span className="pay-amount">฿{toFixed(Number(receipt.change_satang || 0))}</span>
              </div>
              <div className="d-flex justify-content-between align-items-center border-top pt-2">
                <b className="text-18">ยอดรวมใบเสร็จ</b>
                <b className="text-18 pay-amount">฿{toFixed(this.receiptFinalOf(tab.row, receipt))}</b>
              </div>
            </div>
          </>
        )}
      </div>
    );
  };

  render() {
    const s = this.state;
    if (!view_r) return null;

    const index = Math.min(s.active, Math.max(s.tabs.length - 1, 0));
    const tab = s.tabs[index];

    return (
      <div className="w-100 min-vh-100 fade-in">
        <Navbar page1="หน้าหลัก" page2="ข้อมูลจัดเก็บค่าใช้จ่าย" page3="ปรับปรุงใบเสร็จรับเงิน" />

        <div className="body">
          <div className="p-3">
            {/* การ์ดเลือกห้อง + เดือน */}
            <div className="card border-0 p-3 mb-3">
              <h4 className="mb-3">
                <b>ปรับปรุงใบเสร็จรับเงิน</b>
              </h4>
              <div className="row">
                <div className="col-12 col-lg-4 mb-2">
                  <label>บ้านเลขที่</label>
                  <Select className="form-control input-edit w-100 select-search" styles={select_style} options={s.customer_options} value={s.address} onChange={this.changeAddress} />
                </div>
                <div className="col-12 col-md-6 col-lg-4 mb-2">
                  <label>ชื่อ-นามสกุล</label>
                  <input className="form-control w-100 bg-contain border-0" value={s.address?.full_name || ""} disabled />
                </div>
                <div className="col-12 col-md-6 col-lg-4 mb-2">
                  <label>ที่อยู่</label>
                  <input className="form-control w-100 bg-contain border-0" value={s.address?.address || ""} disabled />
                </div>
              </div>

              <div className="d-flex align-items-center justify-content-between mt-2">
                <label className="mb-0">เดือนที่ต้องการปรับปรุง ({s.tabs.length} เดือน)</label>
                <div className="d-flex">
                  {!!s.tabs.length && (
                    <button className="btn btn-outline-danger px-3 mr-2" onClick={() => this.confirmDelete({ type: "all" })}>
                      ลบทั้งหมด
                    </button>
                  )}
                  <button className="btn btn-outline-primary px-3" onClick={this.openMonthModal}>
                    + เพิ่มเดือน
                  </button>
                </div>
              </div>
              {!s.tabs.length && <small className="text-secondary mt-2">เลือกบ้านเลขที่ แล้วกดเพิ่มเดือน เพื่อเลือกงวดค้างชำระที่ต้องการออกใบเสร็จ</small>}
            </div>

            {tab && (
              <>
                {/* tab ต่อ 1 งวด — ลบได้จากงวดใหม่สุดเท่านั้น ปุ่มลบจึงอยู่บนแท็บสุดท้าย */}
                <ul className="nav nav-tabs mb-3">
                  {s.tabs.map((item, i) => (
                    <li className="nav-item" key={item.key}>
                      <button className={`nav-link d-flex align-items-center ${i === index ? "active" : ""}`} onClick={() => this.setState({ active: i })}>
                        {format_date(item.date, "mm/yyyy")} ({item.receipts.length} ใบ)
                        {i === s.tabs.length - 1 && (
                          <label
                            className="wpx-20 hpx-20 bg-danger-light rounded-1 d-flex align-items-center justify-content-center mb-0 ml-2 icon text-danger pointer"
                            title="ลบเดือนได้จากเดือนใหม่สุดเท่านั้น"
                            onClick={(e) => {
                              e.stopPropagation();
                              this.confirmDelete({ type: "month" });
                            }}
                          >
                            {""}
                          </label>
                        )}
                      </button>
                    </li>
                  ))}
                </ul>

                <div className="row">
                  {/* ฝั่งซ้าย — ค่าใช้จ่ายของงวดนั้น (อ่านอย่างเดียว มาจากบิลจริง) */}
                  <div className="col-12 col-xl-5">
                    <div className="card border-0 p-3 mb-3">
                      <b className="mb-3">ค่าใช้จ่ายประจำงวด</b>

                      <div className="row">
                        <div className="col-12 col-md-6 col-lg-3 mb-2">
                          <label>วัน/เดือน/ปี ที่จด</label>
                          <input className="form-control w-100 bg-contain border-0" value={format_date(tab.date, "dd/mm/yyyy")} disabled />
                        </div>
                        <div className="col-12 col-md-6 col-lg-3 mb-2">
                          <label>ขนาดห้อง (ตรม.)</label>
                          <input className="form-control w-100 bg-contain border-0" value={tab.row.room_size || 0} disabled />
                        </div>
                        <div className="col-6 col-lg-3 mb-2">
                          <label>เลขมาตรเดือนก่อน</label>
                          <input className="form-control w-100 bg-contain border-0" value={tab.row.last_gauge_number || 0} disabled />
                        </div>
                        <div className="col-6 col-lg-3 mb-2">
                          <label>เลขมาตรเดือนนี้</label>
                          <input className="form-control w-100 bg-contain border-0" value={tab.row.current_gauge_number || 0} disabled />
                        </div>
                      </div>

                      <div className="table-responsive">
                        <table className="table table-borderless table-striped">
                          <thead>
                            <tr className="bg-dark-blue text-white">
                              <th className="text-center wpx-80">ลำดับที่</th>
                              <th className="text-center">รายการ</th>
                              <th className="text-center wpx-140">สถานะ</th>
                              <th className="text-right wpx-140">ราคารวมสุทธิ</th>
                            </tr>
                          </thead>
                          <tbody>
                            {PAYMENT_KEYS.map((key, i) => {
                              const st = this.itemStatus(tab, key);
                              return (
                                <tr key={key}>
                                  <td className="text-center">{NumberZero(i + 1)}</td>
                                  <td>{PAYMENT_TITLES[key]}</td>
                                  <td className={`text-center text-12 ${st.className}`}>{st.text}</td>
                                  <td className="text-right">{toFixed(amountOf(tab.row, key))}</td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                      <small className="text-secondary">ค่าใช้จ่ายของงวดนี้ดึงจากบิลที่บันทึกไว้แล้ว แก้ไขที่หน้านี้ไม่ได้</small>
                      <div className="w-100 d-flex justify-content-between border-top pt-2">
                        <b>ยอดค้างทั้งงวด (หน่วยที่ใช้ {tab.row.unit_used || 0})</b>
                        <b>฿{toFixed(unpaidAmountOf(tab.row))}</b>
                      </div>
                    </div>
                  </div>

                  {/* ฝั่งขวา — ใบเสร็จที่จะออกของงวดนั้น */}
                  <div className="col-12 col-xl-7">
                    <div className="card border-0 p-3 mb-3">
                      <div className="d-flex align-items-center justify-content-between mb-3">
                        <b>ใบเสร็จของงวดนี้ ({tab.receipts.length} ใบ)</b>
                        <button className="btn btn-outline-primary px-3" onClick={() => this.addReceipt(index)}>
                          + เพิ่มใบเสร็จ
                        </button>
                      </div>

                      {!tab.receipts.length ? (
                        <div className="text-center text-secondary py-4">ยังไม่มีใบเสร็จ กด "เพิ่มใบเสร็จ" เพื่อเลือกว่าจะเก็บค่าอะไรบ้าง</div>
                      ) : (
                        <div className="w-100 p-3 rounded bg-light">
                          {
                        tab.receipts.map((receipt, i) => this.renderReceiptCard(tab, index, receipt, i))
                          }
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                {create_r && (
                  <button className="btn btn-primary w-100 mb-4" onClick={this.Create}>
                    บันทึกและพิมพ์ใบเสร็จทั้งหมด ({s.tabs.reduce((sum, t) => sum + t.receipts.length, 0)} ใบ / {s.tabs.length} งวด)
                  </button>
                )}
                <small className="text-secondary d-block mb-4">หมายเหตุ — กดบันทึกครั้งเดียวจะออกใบเสร็จของทุกงวดพร้อมกัน หากงวดใดผิดพลาดจะไม่บันทึกทั้งชุด</small>
              </>
            )}
          </div>
        </div>

        {/* popup เลือกเดือน — งวดค้างชำระของบ้านหลังนี้ */}
        <Modal show={s.modal_month} onHide={() => this.setState({ modal_month: false, month_rows: [] })} size="lg">
          <Modal.Header>
            <Modal.Title>
              <b>เลือกเดือนที่ต้องการปรับปรุง</b>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <table className="table table-borderless table-striped">
              <thead>
                <tr className="bg-dark-blue text-white">
                  <th className="text-center wpx-100">ลำดับที่</th>
                  <th className="text-center">ชื่อ-สกุล</th>
                  <th className="text-center">รายการค้างชำระรายเดือน</th>
                  <th className="text-center">ยอดเงินค้างชำระ</th>
                  <th className="text-center wpx-100">เลือก</th>
                </tr>
              </thead>
              <tbody>
                {s.month_rows.map((item, i) => (
                  <tr key={item.record_water_id}>
                    <td className="text-center wpx-100">{NumberZero(i + 1)}</td>
                    <td className="text-center">{item.full_name}</td>
                    <td className="text-center">{format_date(item.datetime_create, "MMMM YYYY")}</td>
                    <td className="text-center">{toFixed(unpaidAmountOf(item))}</td>
                    <td className="text-center wpx-100">
                      {/* งวดของลูกหนี้คนอื่นจะติ๊กไม่ได้ */}
                      <input
                        type="checkbox"
                        className="mr-2"
                        checked={!!item.checked}
                        disabled={s.ref_customer_id !== "" && s.ref_customer_id !== item.ref_customer_id}
                        onChange={(e) => this.toggleMonthRow(i, e.target.checked)}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <small className="text-secondary">ต้องเลือกไล่จากงวดเก่าไปงวดใหม่ — ติ๊กงวดใหม่ระบบจะติ๊กงวดเก่ากว่าให้อัตโนมัติ</small>
            <div className="w-100 d-flex mt-3">
              <div className="w-50 p-1">
                <button className="btn btn-outline-primary w-100" onClick={() => this.setState({ modal_month: false, month_rows: [] })}>
                  ยกเลิก
                </button>
              </div>
              <div className="w-50 p-1">
                <button className="btn btn-primary w-100" onClick={this.confirmMonths}>
                  บันทึก
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>

        {/* ใบเสร็จที่เพิ่งออก — กดพิมพ์ทีละใบ หรือพิมพ์รวดเดียวทั้งหมด
            backdrop="static" + keyboard={false} = เผลอกดข้างนอกหรือกด Esc แล้วไม่ปิด ต้องกดปุ่มปิดเท่านั้น */}
        <Modal show={s.modal_print} size="lg" centered backdrop="static" keyboard={false} onHide={() => {}}>
          <Modal.Header className="border-0 pb-0">
            <Modal.Title className="fw-bold">ใบเสร็จที่ออกแล้ว ({s.created_receipts.length} ใบ)</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="mb-3">
              <button className="btn btn-primary px-4" disabled={!s.created_receipts.length} onClick={this.PrintAll}>
                พิมพ์ทั้งหมด ({s.created_receipts.length} ใบ)
              </button>
              <small className="text-secondary d-block mt-2">พิมพ์ทั้งหมด = เปิดเอกสารเดียว เรียงใบเสร็จต่อกันลงมา ขึ้นหน้าใหม่ทุกใบ</small>
            </div>
            <div className="border-top">
              {s.created_receipts.map((iw_number, i) => (
                <div className="w-100 d-flex align-items-center justify-content-between border-bottom py-2" key={iw_number}>
                  <label className="mb-0">
                    {i + 1}. {iw_number}
                  </label>
                  <button className="btn btn-outline-primary px-4" onClick={() => this.Print(iw_number)}>
                    พิมพ์ใบนี้
                  </button>
                </div>
              ))}
            </div>
          </Modal.Body>
          <Modal.Footer className="border-0 pt-0">
            <button className="btn btn-outline-success px-5" onClick={() => this.setState({ modal_print: false, created_receipts: [] })}>
              ปิด
            </button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
